import { render, staticRenderFns } from "./scroll-pane.vue?vue&type=template&id=3b0daa09&scoped=true"
import script from "./scroll-pane.vue?vue&type=script&lang=js"
export * from "./scroll-pane.vue?vue&type=script&lang=js"
import style0 from "./scroll-pane.vue?vue&type=style&index=0&id=3b0daa09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0daa09",
  null
  
)

export default component.exports